import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { CuttingButt } from '../../../models/cutting/cutting-butt.model';
import { OutlineEditorOptions } from '../../../models/user/outline-editor-options.model';
import { MaterialBaseButtsDialogComponent } from '../../material-base-butts-dialog/material-base-butts-dialog.component';

@Component({
  selector: 'csl-butt-select',
  templateUrl: './butt-select.component.html',
})
export class ButtSelectComponent implements OnInit {
  _butt: CuttingButt = undefined;
  materialBaseDialogRef: MatDialogRef<MaterialBaseButtsDialogComponent>;
  outlineOptions: OutlineEditorOptions;

  @Input() set selected(val: CuttingButt) {
    this._butt = val;
  }
  @Input() butts: CuttingButt[] = [];
  @Input() disabled = false;
  @Input() editable = true;
  @Output() selectedChange: EventEmitter<CuttingButt> = new EventEmitter<CuttingButt>();

  @Input()
  get dense() {
    return this._dense;
  }
  set dense(value: BooleanInput) {
    this._dense = coerceBooleanProperty(value);
  }
  _dense = false;

  constructor(
    public dialog: MatDialog //
  ) {}

  ngOnInit(): void {}

  onButtChange(): void {
    this.selectedChange.emit(this._butt);
  }

  openMaterialBaseDialog(): void {
    this.materialBaseDialogRef = this.dialog.open(MaterialBaseButtsDialogComponent, {
      panelClass: 'material-base-butt-list-dialog',
      disableClose: false,
      width: '1000px',
      data: {},
    });

    this.materialBaseDialogRef.afterClosed().subscribe((result: CuttingButt | undefined) => {
      if (result) {
        this.butts.push(result);
        this._butt = result;
        this.onButtChange();
      }
      this.materialBaseDialogRef = null;
    });
  }
}
